import { useQuery } from 'react-query';
import { QueryId, STALE_TIME } from '@/integrations/content/utils';
import formatUrlSearchParameters from '@/libraries/formatters/format-url-search-parameters';
import getCulture from '@/libraries/getters/get-culture';
import getLocale from '@/libraries/getters/get-locale';

type UseQueryRetrieveSharedFavoritesData =
  Offers.Responses.GetRetrieveHotelsWithOffers;

interface UseQueryRetrieveSharedFavoritesOptions {
  enabled?: boolean;
  initialData?: UseQueryRetrieveSharedFavoritesData;
}

interface UseQueryRetrieveSharedFavoritesParameters {
  key: string;
}

const useQueryRetrieveSharedFavorites = (
  parameters: UseQueryRetrieveSharedFavoritesParameters,
  { enabled = true, initialData }: UseQueryRetrieveSharedFavoritesOptions,
) => {
  const locale = getLocale();

  const query = useQuery<UseQueryRetrieveSharedFavoritesData>(
    [QueryId.RETRIEVE_SHARED_FAVORITES, parameters, locale],
    async () => {
      const baseUrl = '/api/favorites/share/retrieve-hotels-with-offers';
      const queryParameters = formatUrlSearchParameters(parameters);

      const fetchResponse = await fetch(
        `${baseUrl}?${queryParameters.toString()}`,
        {
          headers: {
            ['Accept-Language']: getCulture(locale),
            ['Content-Type']: 'application/json',
          },
          method: 'GET',
        },
      )
        .then(response => {
          if (response.ok) return response.json();

          throw new Error(`${response.status} - ${response.statusText}`);
        })
        .catch(error => {
          console.error('hooks.useQueryRetrieveSharedFavorites', error);

          throw error;
        });

      return fetchResponse;
    },
    {
      enabled: !!parameters && enabled,
      initialData,
      keepPreviousData: true,
      staleTime: STALE_TIME,
    },
  );

  return query;
};

export default useQueryRetrieveSharedFavorites;
